import { useBuildVars } from '../../../config';
import { useApiQuery } from '../../../api';
import { useGetRegion } from 'src/util/getRegion';

export function useBidDetails(params: BidParams, enabled = false) {
  const buildVars = useBuildVars();
  const region = useGetRegion();
  return useApiQuery<BidDetailsResponse>(
    '/system.webapi.parserhub/getJSON',
    {
      ...params,
      'IM-Region': region,
    },
    { enabled: enabled },
    { 'IM-Region': region },
    {
      host: buildVars.VP_PARSING_API_BASE,
    }
  );
}

export type BidParams = {
  countryCode: string;
  headerId: string;
};

export type BidDetailsResponse = {
  Action: string;
  Address: string;
  AtatchmentData: any[];
  BidCurrency: string;
  BidEndDate: string;
  BidNotes: string;
  BidNumber: string;
  BidPrice: string;
  BidStartDate: string;
  BidTerms: string;
  BidVersion: string;
  BusinessEntity: string;
  City: string;
  ContactEmail: string;
  Country: string;
  DocumentId: string;
  HeaderId: string;
  Name: string;
  PaymentTerms: string;
  ProductLines: ProductLine[];
  ProgramType: string;
  RelationLines: RelationLine[];
  RepresentativeEmail: string;
  RepresentativeName: string;
  State: string;
  TransactionNumber: string;
  VendorName: string;
  VendorProgramName: string;
  ZipCode: string;
};

export type ProductLine = {
  BidNumber?: string;
  BidQuantity: string;
  DealRegistrationID: string;
  Discount: string;
  FrontendBackend: string;
  IMCost: string;
  IMStandardDiscount: string;
  LineComments: string;
  LineEndDate: string;
  LineStartDate: string;
  ListPrice: string;
  MaxQuantity: string;
  PartDescription: string;
  PartNumber: string;
  RenewalEndDate: string;
  RenewalIdentifierType: string;
  RenewalIdentifierValue: string;
  RenewalStartDate: string;
  RenewalTermLength: string;
  ResellerName?: string;
  ResellerStandardDiscount: string;
  ResellerTotal: string;
  SalesAgreementNumber: string;
  TransactionDescription: string;
  TransactionType: string;
  VendorName?: string;
  id?: number | string;
};

export type RelationLine = {
  Address: string;
  City: string;
  ContactEmail: string;
  Country: string;
  EnduserTransactionNumber?: string;
  Name: string;
  ResellerTransactionNumber?: string;
  State: string;
  TierLevel?: string;
  Type: string;
  ZipCode: string;
};
